var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUserDetail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-user-detail",
    transform: "translate(-357 -538)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "btn-primary",
    transform: "translate(357 538)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7",
    "data-name": "Rectangle 7",
    width: 36,
    height: 36,
    rx: 4,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "user-profile",
    transform: "translate(363.403 544.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6920",
    "data-name": "Path 6920",
    d: "M9.987,3.5A3.116,3.116,0,1,1,6.871,6.612,3.116,3.116,0,0,1,9.987,3.5m0-1.246a4.362,4.362,0,1,0,4.362,4.362A4.362,4.362,0,0,0,9.987,2.25Z",
    transform: "translate(-1.506)",
    fill: "#213364"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6921",
    "data-name": "Path 6921",
    d: "M14.713,27.728H13.467V24.612A3.116,3.116,0,0,0,10.351,21.5H6.612A3.116,3.116,0,0,0,3.5,24.612v3.116H2.25V24.612A4.362,4.362,0,0,1,6.612,20.25h3.739a4.362,4.362,0,0,1,4.362,4.362Z",
    transform: "translate(0 -8.03)",
    fill: "#213364"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6922",
    "data-name": "Path 6922",
    d: "M24.75,4.5h6.232V5.746H24.75Z",
    transform: "translate(-10.037 -1.004)",
    fill: "#213364"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6923",
    "data-name": "Path 6923",
    d: "M24.75,10.125h6.232v1.246H24.75Z",
    transform: "translate(-10.037 -3.513)",
    fill: "#213364"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6924",
    "data-name": "Path 6924",
    d: "M24.75,15.75h4.362V17H24.75Z",
    transform: "translate(-10.037 -6.022)",
    fill: "#213364"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUserDetail);
export default __webpack_public_path__ + "static/media/icon-user-detail.763fdf02c09467fb748985748a8af816.svg";
export { ForwardRef as ReactComponent };